import { createNode } from '@glueapp/graph-types';

export const Not = createNode({
    id: 'Not',
    name: 'Not',
    description: 'Turns a true input value into a false one and a false one into a true one',
    aiDescription: 'Logical NOT (negation). Connect a boolean to the "Input" port; the "Output" port returns the opposite value.',
    category: 'Logic',
    color: '#cd6205',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'boolean',
        },
    },
    outPorts: {
        Output: {
            kind: 'boolean',
        },
    },
    execute: function (input) {
        const inputValue = input.inPorts.Input;

        return { output: { Output: !inputValue } };
    },
});
